export function convertToMapWithKey<T>(list: T[]): Map<string, T> {
  return list.reduce((map, item) => {
    map.set(crypto.randomUUID(), item);
    return map;
  }, new Map());
}
